module.exports = __webpack_public_path__ + "static/media/Slovenia.fccb0101.png";